import * as constants from './constants';

export function fetchUtensils() {
  return {
    type: constants.FETCH_UTENSILS
  };
}

export function fetchUtensilsDone(ppsis) {
  return {
    type: constants.FETCH_UTENSILS_DONE,
    payload: ppsis
  };
}

export function fetchUtensilsFail(error) {
  return {
    type: constants.FETCH_UTENSILS_FAIL,
    payload: error
  };
}

// Added to fetch market utensils

export function fetchMarketUtensils(market) {
  return {
    type: constants.FETCH_MARKET_UTENSILS,
    payload: market
  };
}

export function fetchMarketUtensilsDone(ppsis) {
  return {
    type: constants.FETCH_MARKET_UTENSILS_DONE,
    payload: ppsis
  };
}

export function fetchMarketUtensilsFail(error) {
  return {
    type: constants.FETCH_MARKET_UTENSILS_FAIL,
    payload: error
  };
}
